module.exports = __webpack_public_path__ + "img/dragon1.0ff667c1.gif";